export default "__VITE_ASSET__BVI2Iq5L__"